import { render, staticRenderFns } from "./PlansSection.vue?vue&type=template&id=7514f648&scoped=true"
import script from "./PlansSection.vue?vue&type=script&lang=js"
export * from "./PlansSection.vue?vue&type=script&lang=js"
import style0 from "./PlansSection.vue?vue&type=style&index=0&id=7514f648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7514f648",
  null
  
)

export default component.exports